import s from './week-calendar.module.scss';
import classNames from 'classnames';
import { getDate, isSameDay } from 'date-fns';
import { formatDateKey, WEEK_DAY_NAMES } from '../../lib/date';

export const WeekCalendar = ({
  days,
  selectedDate,
  appointmentsByDay,
  timezone,
  onSelectDay,
}) => (
  <div className={s.weekDaysRow}>
    {days.map((date, index) => {
      const key = formatDateKey(date, timezone);
      const count = (appointmentsByDay[key] || []).length;
      const isSelected = isSameDay(date, selectedDate);
      const isWeekend = index >= 5;

      return (
        <button
          key={date.toISOString()}
          className={classNames(
            s.weekDay,
            isSelected && s.selected,
            isWeekend && !isSelected && s.weekend
          )}
          onClick={() => onSelectDay(date)}
          type="button"
        >
          {count > 0 && <span className={s.weekDayCount}>{count}</span>}
          <span className={s.weekDayNumber}>{getDate(date)}</span>
          <span className={s.weekDayName}>{WEEK_DAY_NAMES[index]}</span>
        </button>
      );
    })}
  </div>
);
